/**
 * @generated SignedSource<<7f6875bc9f645bc88626c769fb508a3c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contactPointSystemId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contactPointUseId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveFrom"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveTo"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "facilityContactPointId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "value"
},
v6 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "contactPointSystemId",
        "variableName": "contactPointSystemId"
      },
      {
        "kind": "Variable",
        "name": "contactPointUseId",
        "variableName": "contactPointUseId"
      },
      {
        "kind": "Variable",
        "name": "effectiveFrom",
        "variableName": "effectiveFrom"
      },
      {
        "kind": "Variable",
        "name": "effectiveTo",
        "variableName": "effectiveTo"
      },
      {
        "kind": "Variable",
        "name": "facilityContactPointId",
        "variableName": "facilityContactPointId"
      },
      {
        "kind": "Variable",
        "name": "value",
        "variableName": "value"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "display",
    "storageKey": null
  },
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditFacilityContactPointModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FacilityMutationGroup",
        "kind": "LinkedField",
        "name": "facility",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "FacilityContactPointModifyPayload",
            "kind": "LinkedField",
            "name": "modifyContactPoint",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityContactPoint",
                "kind": "LinkedField",
                "name": "facilityContactPoint",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Facility",
                    "kind": "LinkedField",
                    "name": "facility",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityContactPoint",
                        "kind": "LinkedField",
                        "name": "contactPoints",
                        "plural": true,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "FacilityContactPoints_ContactPoints"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditFacilityContactPointModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FacilityMutationGroup",
        "kind": "LinkedField",
        "name": "facility",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "FacilityContactPointModifyPayload",
            "kind": "LinkedField",
            "name": "modifyContactPoint",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityContactPoint",
                "kind": "LinkedField",
                "name": "facilityContactPoint",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Facility",
                    "kind": "LinkedField",
                    "name": "facility",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityContactPoint",
                        "kind": "LinkedField",
                        "name": "contactPoints",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContactPointSystemCode",
                            "kind": "LinkedField",
                            "name": "contactPointSystemCode",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContactPointUseCode",
                            "kind": "LinkedField",
                            "name": "contactPointUseCode",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveFrom",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveTo",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bec44869dd046e0058aebcee78db4f52",
    "id": null,
    "metadata": {},
    "name": "EditFacilityContactPointModalMutation",
    "operationKind": "mutation",
    "text": "mutation EditFacilityContactPointModalMutation(\n  $facilityContactPointId: ID!\n  $contactPointSystemId: ID!\n  $contactPointUseId: ID!\n  $value: String!\n  $effectiveFrom: DateOnly!\n  $effectiveTo: DateOnly!\n) {\n  facility {\n    modifyContactPoint(input: {facilityContactPointId: $facilityContactPointId, contactPointSystemId: $contactPointSystemId, contactPointUseId: $contactPointUseId, value: $value, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {\n      facilityContactPoint {\n        id\n        facility {\n          contactPoints {\n            ...FacilityContactPoints_ContactPoints\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment FacilityContactPoints_ContactPoints on FacilityContactPoint {\n  id\n  contactPointSystemCode {\n    display\n    id\n  }\n  contactPointUseCode {\n    display\n    id\n  }\n  value\n  effectiveFrom\n  effectiveTo\n}\n"
  }
};
})();

node.hash = "70a8a594608d194ba963e4bb2908b4ae";

export default node;
